import { useState } from "react";

import { Button, ModalDelete } from "expano-components";

import { Main, PageLoader, Error } from "components";
import useGet from "hooks/useGet";
import useDelete from "hooks/useDelete";

import { ReactComponent as ProductIcon } from "icons/product.svg";

import BasicData from "./components/BasicData";

const RootTaxonEdit = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const [show_delete_modal, setShowDeleteModal] = useState(false);

  const {
    is_loading,
    is_error,
    error,
    data: root_taxon,
    refetch,
  } = useGet({
    query: ["root_taxon", id],
    path: `/root_taxons/${id}`,
    context: "ui_show",
  });

  const { is_deleting, _delete } = useDelete({
    path: `/root_taxons/${id}`,
    onSuccess: () => history.push("/root_taxons"),
  });

  if (is_loading) {
    return <PageLoader />;
  }

  if (is_error) {
    return <Error message={error} />;
  }

  return (
    <Main
      page={{
        name: root_taxon?.name,
        icon: <ProductIcon />,
        breadcrumbs: [
          {
            name: "Kategorie root",
            path: "/root_taxons",
          },
          { name: root_taxon?.name },
        ],
        buttons: (
          <Button
            type="delete"
            text="Usuń kategorię"
            disabled={is_deleting}
            onClick={() => setShowDeleteModal(true)}
          />
        ),
      }}
    >
      {show_delete_modal && (
        <ModalDelete
          handleDelete={_delete}
          handleClose={() => setShowDeleteModal(false)}
          name={`kategorię ${root_taxon?.name}?`}
        />
      )}
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <BasicData
            root_taxon_id={id}
            refetch={refetch}
            initialValues={{
              name: root_taxon?.name,
              identifier: root_taxon?.identifier,
              parent_id: root_taxon?.parent?.id,
            }}
          />
        </div>
      </div>
    </Main>
  );
};

export default RootTaxonEdit;
